import { useEffect, useState } from "react";
import { Input } from "reactstrap";
import "./PaymentPageB2CSection.scss";
import BreadCrumbComponent from "../../Misc/BreadCrumb/BreadCrumbComponent";
import ProductCardComponent from "../../ProductCard/ProductCardComponent";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import {
  cartPageDataClear,
  fetchPaymentIntent,
  fetchProductPI,
  fetchProductPIClear,
  fetchProviderCheckout,
  fetchProviderCheckoutClear,
  fetchSubscriptionPIPage,
  fetchSubscriptionPIPageClear,
  providerSubscriptionCheckoutPageClear,
  subscriptionCheckoutPageClear,
} from "../../../../redux/checkout/actions";
import CONFIG from "../../../../utils/config";
import API_LIST from "../../../../utils/apiList";
import ShimmerScreen from "../../../Layouts/ShimmerScreen";
import LeftPanelPaymentSection from "../LeftPanelPayment/LeftPanelPaymentSection";
import RightPanelPaymentSection from "../RightPanelPayment/RightPanelPaymentSection";
import FormButtonComponent from "../../FormControl/FormButton/FormButtonComponent";
import { CheckoutLockIcon } from "../../../../utils/SvgComps";
import Spinner from "react-bootstrap/Spinner";
import PaymentProcessingSection from "../PaymentProcessingSection/PaymentProcessingSection";
import PaymentStatusSection from "../PaymentStatusSection/PaymentStatusSection";
import useLogin from "../../../../custom-hooks/useLogin";
import { SessionKeys, formatCartProductData, isMainDomain } from "../../../../utils/AppUtils";
import { routeList } from "../../../../utils/routeList";
import { getMembershipIntent } from "../../../../redux/membership/actions";
import { couponCodeApplyClear } from "../../../../redux/Cart/actions";
import { getSubscriptionPlanClear } from "../../../../redux/subscription/actions";
import { isAndroid, isIOS } from "react-device-detect";

const PaymentPageB2CSection = ({ type, isMobile }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoggedIn } = useLogin();
  const location = useLocation();
  const { state } = location;
  console.log("state---",state);
  if(state?.isMobile)
  {
  isMobile = state?.isMobile;
  }

  const [isLoading, setIsLoading] = useState(true);
  const [ecomSubId, setEcomSubId] = useState("");
  const [billingType, setBillingType] = useState("");
  const [province, setProvince] = useState("");
  const [email, setEmail] = useState("");
  const [pidDirectCheckout, setPidDirectCheckout] = useState("");
  const [loadProductCheckout, setLoadProductCheckout] = useState(false);
  const [stripeCustomerId, setStripeCustomerId] = useState("");
  const [stripeSubId, setStripeSubId] = useState("");
  const [paymentInProcess, setPaymentInProcess] = useState(false);
  const [submitForm, setSubmitForm] = useState(false);
  const [enableFormField, setEnableFormField] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const [breadCrumbData, setBreadCrumbData] = useState([
    { name: "Cart", active: false, link: "", isLoading: true },
    { name: "Details", active: false, link: "", isLoading: true },
    { name: "Payment", active: false, link: "", isLoading: true },
  ]);
  const [paymentIntentInfo, setPaymentIntentInfo] = useState({
    isLoading: true,
    total: "",
    subTotal: "",
    discount: 0,
    redeemPoint: 0,
    redeemPrice: 0,
    showRedeemPoint: false,
    taxes: "",
    taxType: "",
    piClientSecret: "",
    subscriptionId: "",
    customerId: "",
    invoiceId: "",
    paymentIntentsToken: "",
    trialDays: "",
    hasTrialDays: false,
    brokerageEmail: "",
  });
  const [membershipCardInfo, setMembershipCardInfo] = useState({
    isLoading: true,
    id: "",
    title: "",
    logoAltText: "",
    logoURL: "",
    bannerURL: "",
    tagsArray: [],
    price: "",
    priceText:"",
  });
  const [providerCardInfo, setProviderCardInfo] = useState({
    isLoading: true,
    id: "",
    code: "",
    title: "",
    logoAltText: "",
    logoURL: "",
    bannerURL: "",
    tagsArray: [],
    price: "",
    isRecurring: false
  })
  const [productCardInfo, setProductCardInfo] = useState([]);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [isRedeemApplied, setIsRedeemApplied] = useState(false)
  const [shouldRedeem, setShouldRedeem] = useState(false)
  const [couponCode, setCouponCode] = useState('')
  const [couponMsg, setCouponMsg] = useState('')
  const [couponErrorMsg, setCouponErrorMsg] = useState('')
  const [couponToApply, setCouponToApply] = useState(false)

  const subscriptionCheckoutPage = useSelector(
    (state) => state.checkout.subscriptionCheckoutPage
  );
  const providerSubCheckoutPage = useSelector(
    (state) => state.checkout.providerSubCheckoutPage
  );
  const fetchSubscriptionPI = useSelector(
    (state) => state.checkout.fetchSubscriptionPI
  );
  const fetchProductPIData = useSelector(
    (state) => state.checkout.fetchProductPI
  );
  const paymentUpdateResp = useSelector(
    (state) => state.checkout.paymentUpdateResp
  );
  const providerCheckout = useSelector(
    (state) => state.checkout.providerCheckout
  );
  const providerOrderInfo = useSelector(
    (state) => state.checkout.providerOrderInfo
  );
  const sendOrderPlaced = useSelector((state) => state.checkout.sendOrderPlace);
  const cartPageData = useSelector((state) => state.checkout.cartPageData);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const applyCouponRes = useSelector((state) => state.carts.couponCodeApplyRes);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dispatch]);

  useEffect(() => {
    console.log("type1",subscriptionCheckoutPage);
    console.log("type2 Cart Page Data", cartPageData);
    // setSearchParams('hello')
    if (_.isEmpty(subscriptionCheckoutPage) && _.isEmpty(cartPageData) &&
   _.isEmpty(providerSubCheckoutPage)) {
      if (type === "subscription") {
        isMobile
          ? navigate(`${routeList.SUBSCRIPTION_PAGE}?isMobile=${isMobile}`)
          : navigate(routeList.SUBSCRIPTION_PAGE);
      } else if (type === 'coaching') {
        isMobile
          ? navigate(`${routeList.LEARN_COACHING_PAGE}?isMobile=${isMobile}`)
          : navigate(routeList.LEARN_COACHING_PAGE);
      } else {
        isMobile
          ? navigate(`${routeList.CART_PAGE}?isMobile=${isMobile}`)
          : navigate(routeList.CART_PAGE);
      }
      // dispatch(subscriptionCheckoutPageClear())
    } else if (!_.isEmpty(subscriptionCheckoutPage)) {
      setBillingType(subscriptionCheckoutPage.billingType);
      setEcomSubId(_.toNumber(subscriptionCheckoutPage.subscriptionId));
    } else if (!_.isEmpty(cartPageData)) {
      setLoadProductCheckout(cartPageData.load);
      if (cartPageData.productId) {
        setPidDirectCheckout(cartPageData.productId);
        fetchProductCheckoutPIData(cartPageData.productId);
      } else {
        fetchProductCheckoutPIData();
      }
      setBreadCrumbData([
        {
          name: "Home",
          active: false,
          link: isMobile ? "" :routeList.HOME_PAGE,
          isLoading: false,
        },
        {
          name: "Cart",
          active: false,
          link: isMobile? "" : routeList.CART_PAGE,
          isLoading: false,
        },
        { name: "Payment", active: true, link: "", isLoading: false },
      ]);
    } else if (providerSubCheckoutPage) {
      setBreadCrumbData([
        { name: 'Services', active: false, link: isMobile? "" :  routeList.LEARN_COACHING_PAGE, isLoading: false },
        { name: 'Payment', active: true, link: "", isLoading: false }
      ])
      // fetchProviderCheckoutData(providerSubCheckoutPage.productId)
      setPidDirectCheckout(providerSubCheckoutPage.productId)
    } else {
      // alert('Called No One')
    }
    return () => {
      dispatch(subscriptionCheckoutPageClear());
      dispatch(cartPageDataClear());
      dispatch(providerSubscriptionCheckoutPageClear())
    };
  }, [subscriptionCheckoutPage]);

  useEffect(() => {
    if (type === "subscription" && billingType && ecomSubId) {
      fetchSubscriptionPIData();
      setBreadCrumbData([
        {
          name: "Home",
          active: false,
          link: isMobile? "" :routeList.HOME_PAGE,
          isLoading: false,
        },
        {
          name: "Subscription",
          active: false,
          link: isMobile ? "" :routeList.SUBSCRIPTION_PAGE,
          isLoading: false,
        },
        { name: "Payment", active: true, link: "", isLoading: false },
      ]);
    } else if (type === "product" && loadProductCheckout) {
      fetchProductCheckoutPIData();
      // setBreadCrumbData([
      //     { name: 'Home', active: false, link: routeList.HOME_PAGE, isLoading: false },
      //     { name: 'Cart', active: false, link: routeList.CART_PAGE, isLoading: false },
      //     { name: 'Payment', active: true, link: "", isLoading: false }
      // ])
    } else if (type == 'coaching' && pidDirectCheckout) {
      
      if(!_.isEmpty(province)){
      fetchProviderCheckoutData(pidDirectCheckout)}
    }
  }, [billingType, ecomSubId, province, pidDirectCheckout]);

  const provinceMaster = useSelector((state) => state.user.provinceMaster);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  useEffect(()=>{
    console.log("provinceMaster",provinceMaster,userDetailRes)
    if(!isLoggedIn){
        setProvince("ON");
    }else if (!_.isEmpty(provinceMaster)&&!_.isEmpty(userDetailRes)) {
      if (provinceMaster.status === 'success') {
          const plist = provinceMaster.payload.payload
          for (let p of plist) {  
            if (p.name === userDetailRes?.payload?.payload?.office_province) {
                setProvince(p.id);
            }
        }
      }
    }
  },[provinceMaster,userDetailRes])
  

  useEffect(() => {
    if (!_.isEmpty(paymentUpdateResp) || !_.isEmpty(sendOrderPlaced) 
      || !_.isEmpty(providerOrderInfo)) {
    // alert(JSON.stringify(providerOrderInfo))
      isMobile
        ? navigate(`/payment/processing?type=${type}&isMobile=${isMobile}`)
        : navigate("/payment/processing?type=" + type);
      // if (!_.isEmpty(paymentUpdateResp)) {
      //     dispatch(getSubscriptionPlanClear())
      // }
    }
  }, [paymentUpdateResp, sendOrderPlaced, providerOrderInfo]);

  useEffect(() => {
    console.log(fetchSubscriptionPI);
    if (!_.isEmpty(fetchSubscriptionPI)) {
      if (fetchSubscriptionPI.status === "success") {
        const resp = fetchSubscriptionPI.payload.data;
        console.log(resp);
        let tagsArray = [];
        let logoURL = "";
        let logoAltText = "";
        if (resp.provider_info) {
          tagsArray.push(`Xsel ${resp.title} subscription`);
          logoURL = resp.provider_info.provider_img;
          logoAltText = ""
        }
        setMembershipCardInfo({
          isLoading: false,
          id: resp.id,
          title: `Xsel ${resp.title} subscription plan - Renews 
                    ${resp.billing_type === "annually" ? "yearly" : "monthly"}`,
          price: _.toNumber(resp.selling_price).toFixed(2),
          priceText: `$${_.toNumber(resp.selling_price).toFixed(2)}${resp.billing_type === 'annually' ? '/month' : ''}, billed ${resp.billing_type}`,
          bannerURL: resp.subscription_img,
          logoURL,
          logoAltText,
          tagsArray,
        });

        setPaymentIntentInfo({
          isLoading: false,
          ecomSubId: resp.id?resp.id:resp.product_id,
          billingType: resp.billing_type,
          total: _.toNumber(resp.stripe_data.total).toFixed(2),
          subTotal: _.toNumber(resp.stripe_data.sub_total).toFixed(2),
          taxes: _.toNumber(resp.stripe_data.taxes).toFixed(2),
          taxRate: _.toNumber(resp.stripe_data.tax_rate),
          taxType: resp.stripe_data.tax_type,
          paymentIntentId: resp.stripe_data.payment_intent_id,
          piClientSecret: resp.stripe_data.payment_intent_client_secret,
          subscriptionId: resp.stripe_data.subscription_id,
          customerId: resp.stripe_data.stripe_customer_id,
          invoiceId: resp.stripe_data.invoice_id,
          paymentIntentsToken: "",
          hasTrialDays: resp.has_trial_days,
          trialDays: resp.trial_days,
          showRedeemPoint: false,
          redeemPoint: 0,
          redeemPrice: 0,
          brokerageEmail: resp.brokerage_email ? resp.brokerage_email : ""
        });
        setIsCouponApplied(false)
        setIsRedeemApplied(false)
        setShouldRedeem(false)

        setStripeSubId(resp.stripe_data.subscription_id);
        setStripeCustomerId(resp.stripe_data.stripe_customer_id);
      }
      dispatch(fetchSubscriptionPIPageClear());
    }
  }, [fetchSubscriptionPI]);

  useEffect(() => {
    console.log("Product INTENT", fetchProductPIData);
    if (!_.isEmpty(fetchProductPIData)) {
      if (fetchProductPIData.status === "success") {
        const resp = fetchProductPIData.payload.data;
        if (!_.isEmpty(resp)) {
          const cartList = resp.cart_items;
          const couponData = resp.coupon_data;
          let discountAmount = _.toNumber(resp.discount);
          cartList.forEach(element => {
            element.isMobile = isMobile;
          });
          if (!_.isEmpty(couponData)) {
            const couponDiscountAmt = _.toNumber(
              couponData.coupon_discount_amount
            );
            if (couponDiscountAmt > 0) {
              discountAmount = discountAmount + couponDiscountAmt;
              setIsCouponApplied(true);
              if (couponData.message && couponToApply) {
                if (couponData.status) {
                  setCouponMsg(couponData.message)
                  setCouponErrorMsg('')
                } else {
                  setCouponErrorMsg(couponData.message)
                  setCouponMsg('')
                }
                
                setCouponToApply(false)
              } else {
                setCouponErrorMsg('')
                setCouponMsg('')
              }
            } else {
              if (couponData.message) {
                if (couponData.status) {
                  setCouponMsg(couponData.message)
                } else {
                  setCouponErrorMsg(couponData.message)
                }
              }
              setIsCouponApplied(false);
            }
          } else {
            setIsCouponApplied(false);
          }
          setProductCardInfo(
            _.map(cartList, (cartData) => {
              if(isMobile) {
                cartData.isMobile = isMobile;
              }
              return formatCartProductData(cartData);
            })
          );
          setPaymentIntentInfo({
            isLoading: false,
            ecomSubId: "",
            billingType: "",
            discount: _.toNumber(discountAmount).toFixed(2),
            total: isNaN(resp.total) ? 0 : _.toNumber(resp.total).toFixed(2),
            subTotal: isNaN(resp.sub_total) ? 0 : _.toNumber(resp.sub_total).toFixed(2),
            taxes: isNaN(resp.tax_total) ? 0 : _.toNumber(resp.tax_total).toFixed(2),
            taxRate: _.toNumber(resp.tax_percent),
            taxType: "", //resp.tax_type,
            paymentIntentId: resp.paymentIntentsToken,
            piClientSecret: resp.client_secret,
            subscriptionId: "", //resp.subscription_id,
            customerId: "", //resp.stripe_customer_id,
            invoiceId: "", //resp.invoice_id
            paymentIntentsToken: resp.paymentIntentsToken,
            productId: pidDirectCheckout,
            showRedeemPoint: resp.show_reward_section ? resp.show_reward_section : false,
            redeemPoint: resp.remaining_redeem_point ? resp.remaining_redeem_point : 0,
            redeemPrice: resp.redeem_price ? _.toNumber(resp.redeem_price).toFixed(2) : 0,
            brokerageEmail: "",
          });
          setIsRedeemApplied(resp.redeem_applied ? resp.redeem_applied : false)
          setShouldRedeem(resp.redeem_applied ? resp.redeem_applied : false)
          if (resp.session_id) {
            localStorage.setItem(SessionKeys.SESSION_ID, resp.session_id);
          }

          // setStripeCustomerId(resp.stripe_data.stripe_customer_id)
        }
      }
      dispatch(fetchProductPIClear());
    }
  }, [fetchProductPIData]);

  useEffect(() => {
    if (!_.isEmpty(providerCheckout)) {
      if (providerCheckout.status === 'success') {
        const resp = providerCheckout.payload.payload;
        let tagsArray = [];
        let logoURL = "";
        let logoAltText = "";
        if (!_.isEmpty(resp.provider_info)) {
          tagsArray.push(resp.provider_info.display_name)
          logoURL = resp.provider_info.image
          logoAltText = ""
        }
        tagsArray.push('Services')
        tagsArray.push(resp.payment_frequency === 'monthly' ? 'Subscription': 'One Time')
        setProviderCardInfo({
          isLoading: false,
          id: resp.product_id,
          code: resp.code,
          title: resp.product_title,
          price: _.toNumber(resp.selling_price).toFixed(2),
          bannerURL: resp.product_img,
          isRecurring: resp.payment_frequency === 'monthly',
          logoURL,
          logoAltText,
          tagsArray,
          type:"service",
          isMobile: _.toLower(isMobile) === "true" ? true : false
        })
        setPaymentIntentInfo({
          isLoading: false,
          ecomSubId: resp.product_id,
          billingType: resp.payment_frequency,
          total: _.toNumber(resp.stripe_data.total).toFixed(2),
          subTotal: _.toNumber(resp.stripe_data.sub_total).toFixed(2),
          taxes: _.toNumber(resp.stripe_data.taxes).toFixed(2),
          taxRate: _.toNumber(resp.stripe_data.tax_rate),
          taxType: resp.stripe_data.tax_type,
          paymentIntentId: resp.stripe_data.payment_intent_id,
          piClientSecret: resp.stripe_data.payment_intent_client_secret,
          subscriptionId: resp.stripe_data.subscription_id,
          customerId: resp.stripe_data.stripe_customer_id,
          invoiceId: resp.stripe_data.invoice_id,
          paymentIntentsToken: "",
          hasTrialDays: 0,
          trialDays: 0,
          showRedeemPoint: false,
          redeemPoint: 0,
          redeemPrice: 0,
          brokerageEmail: "",
        });
        setIsCouponApplied(false)
        setIsRedeemApplied(false)
        setShouldRedeem(false)
        setStripeSubId(resp.stripe_data.subscription_id);
        setStripeCustomerId(resp.stripe_data.stripe_customer_id);
      }
      dispatch(fetchProviderCheckoutClear())
    }
  }, [providerCheckout])

  useEffect(() => {
    // console.log('couponCodeApplyRes12:, ', applyCouponRes)
    if (!_.isEmpty(applyCouponRes)) {
      if (applyCouponRes.status === "success") {
        if (pidDirectCheckout) fetchProductCheckoutPIData(pidDirectCheckout)
        else fetchProductCheckoutPIData();
      }
      dispatch(couponCodeApplyClear());
    }
  }, [applyCouponRes]);

  useEffect(() => {
    if (type === 'product') {
      if (pidDirectCheckout) fetchProductCheckoutPIData(pidDirectCheckout)
      else fetchProductCheckoutPIData();
      setPaymentIntentInfo({
        isLoading: true
      })
    }
  }, [shouldRedeem, couponCode])

  const fetchSubscriptionPIData = () => {
    let payload = {
      subscription_id: ecomSubId,
      billing_type: billingType,
    };
    if (province) {
      payload.province = province;
    }
    if (stripeSubId) {
      payload.stripe_subscription_id = stripeSubId;
    }
    if (stripeCustomerId) {
      payload.customer_id = stripeCustomerId;
    }
    if (email) {
      payload.email = email;
    }
    if (isLoggedIn) {
      payload.token = isMobile
        ? localStorage.getItem(SessionKeys.API_TOKEN)
        : localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
    }
    dispatch(
      fetchSubscriptionPIPage({
        URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.GET_SUBSCRIPTION_PI}`,
        isJSON: true,
        method: "post",
        payload,
      })
    );
  };

  const fetchProductCheckoutPIData = (productId = "") => {
    console.trace('hello')
    let payload = {
      token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      province_id: province,
    };
    if (pidDirectCheckout) {
      payload.product_id = pidDirectCheckout;
    }
    if (productId) {
      payload.product_id = productId;
    }
    if (stripeCustomerId) {
      payload.customer_id = stripeCustomerId;
    }
    if (
      !localStorage.getItem(SessionKeys.API_TOKEN_BROKER) &&  !localStorage.getItem(SessionKeys.API_TOKEN) &&
      localStorage.getItem(SessionKeys.SESSION_ID)
    ) {
      payload.session_id = localStorage.getItem(SessionKeys.SESSION_ID);
    }

    if (shouldRedeem) {
      payload.redeem = true
    }

    if (couponCode) {
      payload.coupon_code = couponCode
    }

    dispatch(
      fetchProductPI({
        URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.PRODUCT_PAYMENT_CHECKOUT}`,
        isJSON: true,
        method: "post",
        payload,
      })
    );
  };

  const fetchProviderCheckoutData = (productId = "") => {
    dispatch(
      fetchProviderCheckout({
        module: 'fetchProviderCheckout',
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            product_id: productId,
            province: province
          }
      })
    )
  }

  const renderPaymentButton = () => {
    return (
      <div className="row">
        <div className="col-12">
          <FormButtonComponent
            btnName={
              paymentInProcess ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  variant="primary"
                />
              ) : (
                "Pay"
              )
            }
            leftIcon={<CheckoutLockIcon />}
            btnAction={() => setSubmitForm(true)}
            isPrimary={true}
            disabled={!enableFormField}
            replaceClassName={"btn-form-comp w-100 mt-4"}
          />
        </div>
      </div>
    );
  };

  const renderTrialLiner = () => {
    return (
      <>
        <div className="row">
          <div className="col-12 authorize-liner">
            After the {paymentIntentInfo.trialDays} days free trial ends, you
            will be automatically charged for your{" "}
            {paymentIntentInfo.billingType} subscription fee.
          </div>
        </div>
      </>
    );
  };

  const renderAutoRenew = () => {
    return (
      <div className="row">
        <div className="col-12 authorize-liner">
          By clicking on 'Pay', you are authorizing for auto renewal of your{" "}
          {paymentIntentInfo.billingType} subscription fee.
        </div>
      </div>
    );
  };

//   const [loggedIn, setLoggedIn] = useState(false);
//   useEffect(() => {
//    setLoggedIn(true);
//   }, [localStorage.getItem(localStorage.getItem(SessionKeys.API_TOKEN_BROKER)),localStorage.getItem(localStorage.getItem(SessionKeys.API_TOKEN))]);

const search = window.location.search;
const params = new URLSearchParams(search);
const token = params.get("token");

  return (
    <>
      <div className="row payment-b2c">
        <div className="col-12">
          <div className="col-lg-6 col-12">
            <div className="bred-icof justify-content-between">
              <BreadCrumbComponent crumbList={breadCrumbData} />
              {(!isLoggedIn && !token) && (
                <div className="signin-option">
                  Have an account?{" "}
                  <button
                    type="button"
                    className="reset-btn"
                    onClick={() => {
                      console.log("callback true");
                      if (isAndroid || isIOS) {
                        try {
                         
                          if (window.callbackHandler != undefined) {
                             window.callbackHandler.postMessage("sign-in-from-checkout");
                          }
                          if (window.webkit != undefined) {
                            if (
                              window.webkit.messageHandlers.callbackHandler !=
                              undefined
                            ) {
                              window.webkit.messageHandlers.callbackHandler.postMessage(
                                "sign-in-from-checkout"
                              );
                            }
                          }
                        } catch (err) {
                          console.log("error in sending message",err);
                        }
                      }

                      if(isMainDomain()){
                          navigate("/verify-user")// navigate('/login')
                      }else{
                          navigate("/")
                      }
                      // navigate(routeList.LOGIN_PAGE, {
                      //   state: { path: "/subscription" },
                      // });
                    }}
                  >
                    <strong>Sign in</strong>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row gx-lg-5">
        <div className="col-12 col-lg-8">
          <LeftPanelPaymentSection
            setProvince={setProvince}
            setEmail={setEmail}
            paymentIntentInfo={paymentIntentInfo}
            paymentInProcess={paymentInProcess}
            setPaymentInProcess={setPaymentInProcess}
            submitForm={submitForm}
            setSubmitForm={setSubmitForm}
            enableFormField={enableFormField}
            setEnableFormField={setEnableFormField}
            setErrorMsg={setErrorMsg}
            type={type}
            isMobile={isMobile}
            couponCode={couponCode}
            isCouponApplied={isCouponApplied}
            shouldRedeem={shouldRedeem}
          />
        </div>
        <div className="col-lg-4 col-12 payment-right-box">
          <RightPanelPaymentSection
            membershipCardInfo={membershipCardInfo}
            paymentIntentInfo={paymentIntentInfo}
            productCardInfo={productCardInfo}
            providerCardInfo={providerCardInfo}
            isCouponApplied={isCouponApplied}
            isRedeemApplied={isRedeemApplied}
            showOnlyInfo={false}
            isLoggedIn={isLoggedIn}
            type={type}
            isMobile={isMobile}
            setShouldRedeem={setShouldRedeem}
            shouldRedeem={shouldRedeem}
            pidDirectCheckout={pidDirectCheckout}
            setCouponCode={setCouponCode}
            couponCode={couponCode}
            couponMsg={couponMsg}
            setCouponMsg={setCouponMsg}
            couponErrorMsg={couponErrorMsg}
            setCouponErrorMsg={setCouponErrorMsg}
            setCouponToApply={setCouponToApply}
          />
          {renderPaymentButton()}
          {!paymentIntentInfo.isLoading &&
            (paymentIntentInfo.hasTrialDays ? (
              <>
                {renderAutoRenew()}
                {renderTrialLiner()}
              </>
            ) : (
              type === "subscription" && renderAutoRenew()
            ))}
          {
            type === 'coaching' && providerCardInfo.isRecurring && renderAutoRenew()
          }
          <div className="row">
            <div className="col-12">
              <div className="text-red">{errorMsg}</div>
            </div>
          </div>
        </div>
      </div>
      {paymentInProcess && <PaymentProcessingSection />}
    </>
  );
};

export default PaymentPageB2CSection;
